<template>
  <div>
    <vue-snotify></vue-snotify>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"></loading>

    <input ref="fileUpload" type="file" @change="onFileUploaded" hidden />

    <b-progress v-if="isUploading" :value="uploadingValue" height="20px" :max="100" animated>
      <b-progress-bar :value="uploadingValue">
        <div v-if="uploadingValue < 100">{{ uploadingValue }} %</div>
        <div v-else>Processing file to document store</div>
      </b-progress-bar>
    </b-progress>

    <div class="card-body">
      <div class="tree-container">
        <span v-if="treeNodes.length == 0">There are no files for review</span>
        <DocumentExplorerTreeNode class="tree-node" v-for="node in treeNodes" :key="node.name" :node="node"
          :select_mode="select_mode" :is_reviewer="is_reviewer" :is_review="is_review" v-on:upload="onUploadItem" v-on:override="onOverrideItem"
          v-on:delete="onDeleteDocument" v-on:deletePermanently="onDeleteDocumentPermanently"
          v-on:rename="onRenameDocument" v-on:unDelete="onUnDeleteDocument" v-on:download="downloadDocument"
          v-on:reviewDocument="reviewDocument" v-on:saveChanges="saveChanges" v-on:approveDocument="approveDocument"
          v-on:rejectDocument="rejectDocument" />
      </div>
    </div>

    <b-modal id="modal-rename" hide-footer>
      <template #modal-title>
        <h3>Rename</h3>
      </template>

      <validation-observer v-slot="{ handleSubmit }">
        <b-form role="form" @submit.prevent="handleSubmit(saveFileKey)">
          <base-input class="mb-2" name="name" :rules="{ required: true }" v-model="renameKey"></base-input>

          <div class="float-right mt-5">
            <base-button type="primary" native-type="submit">Save</base-button>
            <b-button v-on:click="closeRenameModal()">Cancel</b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal id="modal-confirm-delete-permanently" hide-footer>
      <template #modal-title>
        <h3>Do you want to delete permanently?</h3>
      </template>

      {{ updateDocument.name }}

      <div class="float-right mt-5">
        <b-button variant="primary" v-on:click="confirmDeletePermanently()">Delete</b-button>
        <b-button v-on:click="closeConfirmDeletePermanentlyModal()">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-confirm-delete" hide-footer>
      <template #modal-title>
        <h3>Do you want to delete ?</h3>
      </template>

      {{ updateDocument.name }}

      <div class="float-right mt-5">
        <b-button variant="primary" v-on:click="confirmDelete()">Delete</b-button>
        <b-button v-on:click="closeConfirmDeleteModal()">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-confirm-override" hide-footer>
      <template #modal-title>
        <h3>The file exists. Do you want to overwrite the file?</h3>
      </template>

      <div class="float-right mt-5">
        <b-button variant="primary" v-on:click="onConfirmOverrideModal()">Override</b-button>
        <b-button v-on:click="closeConfirmOverrideModal()">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-confirm-override-double" hide-footer>
      <template #modal-title>
        <h3>Are you sure ?</h3>
      </template>

      <div class="float-right mt-5">
        <b-button variant="primary" v-on:click="onConfirmOverrideModalDouble()">Yes</b-button>
        <b-button v-on:click="closeConfirmOverrideModalDouble()">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="modal-review" hide-footer>
      <template #modal-title>
        <h3>{{ currentReviewFile.fullName }}</h3>

        <label>Reason for rejecting the document</label>
        <b-form-textarea id="textarea" v-model="reasonForRejecting" placeholder="Enter something..." rows="3"
          max-rows="6"></b-form-textarea>

      </template>

      <div class="float-right mt-5">
        <b-button v-on:click="reviewActionDocument(2)">Reject</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import mixins from "./../../mixins/common.js";
import DocumentExplorerTreeNode from "./../DocumentExplorerTreeNode/DocumentExplorerTreeNode.vue";

export default {
  components: {
    DocumentExplorerTreeNode
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      documents: [],
      basePaths: [],
      treeNodes: [],
      reviewObjects: [],
      uploadPath: null,
      isOverride: false,
      renameKey: "",
      updateDocument: "",
      uploadFile: null,
      selectedFileForUpload: null,
      rootFolder: "DocumentStore",
      isUploading: false,
      uploadingValue: 0,
      selectedNodes: [],
      analysts: [],
      selectedAnalyst: null,
      currentReviewFile: "",
      reasonForRejecting: "",
      reviewClaimId: null
    };
  },
  mixins: [mixins],
  props: ["claim_id", "client_id", "select_mode", "is_review"],
  mounted() {
    this.clearSnotifyMessages();

    if (this.client_id && this.claim_id && !this.is_review) {
      this.getDocuments(this.client_id, this.claim_id);
    }

    if (!this.is_review) {
      this.$root.$on('documents-updated', () => {
        this.getDocuments(this.client_id, this.claim_id);
      });
    }
  },
  watch: {
    claim_id: function (newVal) {
      if (!this.is_review) {
        this.getDocuments(this.client_id, this.claim_id);
      }

    },
    client_id: function (newVal) {
      if (!this.is_review) {
        this.getDocuments(this.client_id, this.claim_id);
      }
    }
  },
  computed: {
    ...mapState("user", ["user_id", "is_reviewer"]),
  },
  methods: {
    ...mapActions("admin", ["getAllDocuments", "uploadDocument", "deleteDocument", "deleteDocumentPermanently", "unDeleteDocument", "renameDocument", "checkDocumentExists", "uploadDocument2", "getAnalystsForReview", "getFilesForReview", "reviewActionDocumentRequest", "getDocumentsForReview"]),
    setDocumentsForReview(data, claimId) {
      this.reviewObjects = [];
      this.reviewClaimId = claimId;
      for (let i = 0; i < data.length; i++) {
        this.reviewObjects.push({ id: data[i].id, microsoftFileId: data[i].microsoftFileId, name: data[i].fileName, reviewStatus: data[i].reviewStatus, presignedUrl: data[i].presignedUrl });
      }
      this.treeNodes = [];
      this.buildTreeReview();
    },
    reviewActionDocument(value) {
      let self = this;
      this.isLoading = true;
      this.reviewActionDocumentRequest({ fullName: this.currentReviewFile.fullName, value: value, claimId: this.reviewClaimId, microsoftFileId: this.currentReviewFile.microsoftFileId, reasonForRejection: this.reasonForRejecting }).then((data) => {
        self.$bvModal.hide('modal-review');
        self.$emit('updateDocuments', document);
        this.isLoading = false;
      });
    },
    reviewDocument(document) {
      this.$emit('reviewDocument', document);
    },
    saveChanges(document) {
      this.$emit('saveChanges', document);
    },
    approveDocument(document) {
      this.currentReviewFile = document;
      this.reasonForRejecting = "";
      this.reviewActionDocument(1);
    },
    rejectDocument(document) {
      this.currentReviewFile = document;
      this.reasonForRejecting = "";
      this.$bvModal.show('modal-review');
    },
    getSelectedFiles() {
      this.selectedNodes = [];
      this.getSelected(this.treeNodes);
      return this.selectedNodes;
    },
    getSelected(obj) {
      if (obj) {
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].selected) {
            this.selectedNodes.push(obj[i])
          }
          if (obj[i].children) {
            this.getSelected(obj[i].children);
          }
        }
      }
    },
    getDocuments: function (clientId, claimId, isSelectMode) {
      if (clientId && claimId) {
        this.isLoading = true;
        this.getAllDocuments({ clientId: clientId, claimId: claimId, withDeletedFiles: !this.select_mode, isShowSelected: this.select_mode != null ? this.select_mode : false }).then((data) => {
          if (data && data.data) {
            this.basePaths = data.data;
            this.buildTree();
            this.isLoading = false;
          }
        });
      }
    },
    onOverrideItem: function(document){
      console.log(document);
      this.uploadPath = document.fullName;
      this.isOverride = true;
      this.$refs.fileUpload.click();
    },
    onUploadItem: function (document) {
      let parents = this.getAllParents(document).reverse();
      this.uploadPath = this.rootFolder + "/" + parents.map(parent => parent.name).join('/') + "/" + document.name;
      this.$refs.fileUpload.click();
    },
    sortBasePaths: function () {
      this.basePaths.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      });
    },
    saveFileKey: function () {
      if (this.renameKey) {
        var self = this;
        let parents = this.getAllParents(this.updateDocument).reverse();
        let key = self.rootFolder + "/" + parents.map(parent => parent.name).join('/') + "/" + this.updateDocument.name;
        let newKey = self.rootFolder + "/" + parents.map(parent => parent.name).join('/') + "/" + this.renameKey;

        if (key != newKey) {
          this.renameDocument({ oldKey: key, newKey: newKey }).then(function (data) {
            var oldPath = self.basePaths.find(x => x.name == key);
            oldPath = newKey;

            self.basePaths.map(x => {
              if (x.name == key) {
                x.name = newKey;
                x.lastModified = data.data.success.lastModified;
                x.presignedUrl = data.data.success.presignedUrl;
              }
            });

            self.updateDocument.name = self.renameKey;
            self.updateDocument.lastModified = data.data.success.lastModified;
            self.updateDocument.presignedUrl = data.data.success.presignedUrl;
            self.buildTree();
            self.$bvModal.hide('modal-rename');

            self.$root.$emit('renameDocument');
          });
        }
      }
    },
    closeRenameModal: function () {
      this.$bvModal.hide('modal-rename');
    },
    onRenameDocument: function (document) {
      this.updateDocument = document;
      this.renameKey = document.name;
      this.$bvModal.show('modal-rename');
    },
    onDeleteDocumentPermanently: function (document) {
      this.updateDocument = document;
      this.$bvModal.show('modal-confirm-delete-permanently');
    },
    closeConfirmDeletePermanentlyModal: function () {
      this.$bvModal.hide('modal-confirm-delete-permanently');
    },
    confirmDeletePermanently: function () {
      let self = this;
      let parents = self.getAllParents(self.updateDocument).reverse();
      let key = self.rootFolder + "/" + parents.map(parent => parent.name).join('/') + "/" + self.updateDocument.name;

      self.deleteDocumentPermanently({ key: key }).then(function (data) {
        if (data && data.data.success.status == true) {
          self.basePaths = self.basePaths.filter(x => x.name != self.updateDocument.fullName);
          self.buildTree();
        }
        self.closeConfirmDeletePermanentlyModal();
      });
    },
    closeConfirmDeleteModal: function () {
      this.$bvModal.hide('modal-confirm-delete');
    },
    onUnDeleteDocument: function (document) {
      var self = this;
      this.unDeleteDocument({ key: document.fullName, clientId: this.client_id }).then(function (data) {
        if (data && data.data.success.status == true) {
          self.basePaths = self.basePaths.filter(x => x.name != document.fullName)
          self.basePaths.push({ name: data.data.success.normalKey, presignedUrl: document.presignedUrl, lastModified: data.data.success.lastModified });
          self.buildTree();
          self.$root.$emit('unDeleteDocument');
        }
        self.closeConfirmDeleteModal();
      });
    },
    onDeleteDocument: function (document) {
      this.updateDocument = document;
      this.$bvModal.show('modal-confirm-delete');
    },
    confirmDelete: function () {
      let self = this;
      let parents = self.getAllParents(self.updateDocument).reverse();
      let key = self.rootFolder + "/" + parents.map(parent => parent.name).join('/') + "/" + self.updateDocument.name;

      self.deleteDocument({ key: key, clientId: this.client_id }).then(function (data) {
        if (data && data.data.success.status == true) {
          let recycleBinKey = data.data.success.recycleBinKey;
          self.basePaths = self.basePaths.filter(x => x.name != self.updateDocument.fullName);
          self.basePaths.push({ name: recycleBinKey, presignedUrl: self.updateDocument.presignedUrl, lastModified: data.data.success.lastModified });
          self.buildTree();
          self.$root.$emit('deleteDocument');
        }
        self.closeConfirmDeleteModal();
      });
    },
    getAllParents(currentNode) {
      const parents = [];
      let parent = currentNode.parent;
      while (parent) {
        parents.push(parent);
        parent = parent.parent;
      }
      return parents;
    },
    buildTreeReview() {
      this.treeNodesReview = [];
      this.reviewObjects.forEach((object, i) => {
        this.addPathToTreeReview(object);
      });
    },
    addPathToTreeReview(object) {
      let parts = object.name.split('/');
      parts = parts.slice(1);
      let currentNode = this.treeNodes.find(node => node.name === parts[0]);
      if (!currentNode) {
        currentNode = {
          id: object.id,
          microsoftFileId: object.microsoftFileId,
          name: parts[0],
          children: [],
          selected: false,
          presignedUrl: object.presignedUrl,
          fullName: object.name,
          isRoot: true,
        };
        currentNode.isVisible = currentNode.name != "DocumentStore";
        this.treeNodes.push(currentNode);
      }

      for (let i = 1; i < parts.length; i++) {
        let foundChild = currentNode.children.find(child => child.name === parts[i]);
        if (foundChild) {
          currentNode = foundChild;
        } else {
          let newNode = {
            id: object.id,
            microsoftFileId: object.microsoftFileId,
            name: parts[i],
            children: [],
            selected: false,
            presignedUrl: object.presignedUrl,
            parent: currentNode,
            fullName: object.name,
            isRoot: false,
            reviewStatus: object.reviewStatus
          };
          currentNode.children.push(newNode);
          currentNode = newNode;
        }
      }
    },
    buildTree() {
      this.sortBasePaths();
      this.treeNodes = [];
      this.basePaths.forEach((object, i) => {
        this.addPathToTree(object);
      });
    },
    addPathToTree(object) {
      let parts = object.name.split('/');
      parts = parts.slice(1);
      let currentNode = this.treeNodes.find(node => node.name === parts[0]);
      if (!currentNode) {
        currentNode = {
          name: parts[0],
          children: [],
          selected: false,
          presignedUrl: object.presignedUrl,
          fullName: object.name,
          isRecycleBin: object.name.includes("Recycle Bin"),
          isRoot: true,
          lastModified: object.lastModified
        };
        currentNode.isVisible = currentNode.name != "DocumentStore";
        this.treeNodes.push(currentNode);
      }

      for (let i = 1; i < parts.length; i++) {
        let foundChild = currentNode.children.find(child => child.name === parts[i]);
        if (foundChild) {
          currentNode = foundChild;
        } else {
          let newNode = {
            name: parts[i],
            children: [],
            selected: object.isSelected && i == parts.length -1,
            presignedUrl: object.presignedUrl,
            parent: currentNode,
            fullName: object.name,
            isRecycleBin: object.name.includes("Recycle Bin"),
            isRoot: false,
            lastModified: object.lastModified
          };
          currentNode.children.push(newNode);
          currentNode = newNode;
        }
      }
    },
    downloadDocument(document) {
      window.open(document.presignedUrl, '_blank');
    },
    closeConfirmOverrideModalDouble() {
      this.$refs.fileUpload.value = null;
      this.$bvModal.hide('modal-confirm-override-double');
    },
    closeConfirmOverrideModal() {
      this.$refs.fileUpload.value = null;
      this.$bvModal.hide('modal-confirm-override');
    },
    onConfirmOverrideModalDouble() {
      var self = this;
      var params = {
        clietnId: self.client_id,
        claimId: self.claim_id,
        uploadPath: self.uploadPath,
        uploadFile: self.selectedFileForUpload,
        callBackProgress: self.uploadFileCallBackProgress,
        uploadFileCallBackStart: self.uploadFileCallBackStart,
        uploadFileCallBackFinish: self.uploadFileCallBackFinish
      }

      self.uploadDocument(params).then(function (data) {
        self.basePaths.push({ name: data.fileName, presignedUrl: data.presignedURL, lastModified: data.lastModified });
        self.buildTree();
      });
      self.$bvModal.hide('modal-confirm-override-double');
    },
    onConfirmOverrideModal() {
      this.$bvModal.hide('modal-confirm-override');
      this.$bvModal.show('modal-confirm-override-double');
    },
    onFileUploaded($event) {
      var self = this;

      this.selectedFileForUpload = $event.target.files[0];
      if(this.isOverride){
        var params = {
            isOverride: this.isOverride,
            uploadPath: this.uploadPath,
            uploadFile: this.selectedFileForUpload,
            callBackProgress: this.uploadFileCallBackProgress,
            uploadFileCallBackStart: this.uploadFileCallBackStart,
            uploadFileCallBackFinish: this.uploadFileCallBackFinish
          }
          
        this.uploadDocument(params).then(function (data) {

          self.getDocumentsForReview(self.reviewClaimId).then((data) => {
                self.setDocumentsForReview(data.data.files, data.data.claimRecordId);
          });
        });
        this.isOverride = false;
      }else{
        this.checkDocumentExists(self.uploadPath + "/" + this.selectedFileForUpload.name).then(function (data) {
        if (data && data.data && !data.data.value) {
          var params = {
            clietnId: self.client_id,
            claimId: self.claim_id,
            isOverride: false,
            uploadPath: self.uploadPath,
            uploadFile: self.selectedFileForUpload,
            callBackProgress: self.uploadFileCallBackProgress,
            uploadFileCallBackStart: self.uploadFileCallBackStart,
            uploadFileCallBackFinish: self.uploadFileCallBackFinish
          }

          self.uploadDocument(params).then(function (data) {
            self.basePaths.push({ name: data.fileName, presignedUrl: data.presignedURL, lastModified: data.lastModified });
            self.buildTree();
          });
        } else if (data && data.data && data.data.value) {
          self.uploadFile = {
            selectedFile: self.selectedFileForUpload,
            uploadPath: self.uploadPath
          };
          self.$bvModal.show('modal-confirm-override');
        } else {
          self.$refs.fileUpload.value = null
        }
      });
      }
    },
    uploadFileCallBackProgress(loaded, total) {
      this.uploadingValue = loaded;
    },
    uploadFileCallBackStart() {
      this.uploadingValue = 0;
      this.isUploading = true;
    },
    uploadFileCallBackFinish() {
      this.uploadingValue = 0;
      this.isUploading = false;
      this.$refs.fileUpload.value = null;
    },
    onUploadDocument(folderHierarchyNumber) {
      this.folderHierarchyNumber = folderHierarchyNumber;
      this.$refs.fileUpload.click();
    }
  }
};
</script>

<style scoped>
.documentFile {
  margin-left: 10px;
}

.documentFile:hover {
  background-color: lightgray;
  cursor: pointer;
}

.uploadAction {
  cursor: pointer;
}

.tree-container {
  overflow-x: auto;
  white-space: nowrap;
  max-width: 100%;
}

.tree-node {
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
}

.analyst {
  padding-top: 9px;
  margin-right: 10px;
}
</style>
